module.exports = __webpack_public_path__ + "img/zf.cd3931d9.png";